define.alias("ember-in-viewport/modifiers/in-viewport", "settings/modifiers/in-viewport");